<template>
    <ui-crud title="Non-Conformance Reports"
             ref="crud"
             :subtitle="!packageReference?'List of all Non Conformance Reports':'Manage package Non Conformance Reports'"
             :fetch="fetch" :pipe-with="pipeItems" :group-by="groupByStatus"
             :read-only="!packageReference">
        <template #new-button>
            <div class="flex items-center">
                <h1 class="text-lg font-medium text-gray-900">Non-Conformance Reports</h1>
                <ui-button-new small class="ml-auto hidden sm:inline-flex" icon="fas fa-plus" v-if="packageReference"
                               @click.prevent="createNew()">New
                </ui-button-new>
            </div>
            <p class="mt-1 text-sm text-gray-600">All Non-Conformance Reports for this package</p>
            <ui-button-new class="sm:hidden mt-4" icon="fas fa-plus" v-if="packageReference"
                           @click.prevent="createNew()">New
            </ui-button-new>
        </template>

        <!-- Filters. -->
        <template #filters="{ debouncedRefresh }">
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="`NCR #${item.reference}`"
                :subtitle="item.title"
                :metadata="item.date?item.formattedDate:''"
                :active="active"
                @click="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem }">
            <div class="flex space-x-8 pt-4 px-4 m-4 justify-center items-center">
                <div
                    class="border border-grey-200 rounded-l bg-gray-50 w-full h-full p-4 justify-center items-center text-center text-gray-500">
                    <-- Please select an existing Non-Conformance Report to view/edit or click new to create a new one.
                </div>
            </div>
        </template>

        <!-- Edit form. -->
        <template #edit="{ selectedItem, setEditMode, removeItem }">
            <non-conformance-report-form :package-reference="packageReference"
                                         :package-name="packageName"
                                         :item="selectedItem" :edit="setEditMode"
                                         :remove-item="removeItem"></non-conformance-report-form>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem }">
            <non-conformance-report-show :item="selectedItem" :edit="setEditMode"
                                         ref="form"
                                         :remove-item="removeItem"></non-conformance-report-show>
        </template>
    </ui-crud>
</template>

<script>
import {NonConformanceReport} from '@models'
import UiButtonNew from "../../ui/UiButtonNew.vue";
import UiCrud from "../../ui/UiCrud.vue";
import {uuid} from "../../../utils";
import moment from "moment/moment";

export default {
    components: {UiCrud, UiButtonNew},
    props: {
        packageReference: null,
        packageName: null,
        showWhenLoaded: null
    },
    data() {
        return {
            search: '',
        }
    },
    methods: {
        async createNew() {
            let id = uuid();
            this.search = '';
            await NonConformanceReport.create(this.packageReference, {
                id: id,
                date: moment().format("YYYY-MM-DD"),
                packageName: this.packageName,
            });
            await this.$refs.crud.fetchItems();
            this.$nextTick(() => {
                this.$refs.crud.selectItem(this.$refs.crud.items.find((i) => i.id === id));
                this.$nextTick(() => {
                    this.$refs.form.toggleEditMode(true)
                })
            })
        },
        selectItem(item, select, setEditMode) {
            select()
        },
        async fetch(itemId) {
            this.loaded = false
            this.items = await NonConformanceReport.all(this.packageReference)
            if (itemId) {
                this.$refs.crud.selectItem(this.items.find((i) => i.id === itemId))
            } else if (this.items.length) {
                this.$refs.crud.selectItem(this.items[0])
            }
            this.loaded = true
            return this.items;
        },
        pipeItems(items) {
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.-\/]+/);
            let newItems = items;
            if (query.length) {
                newItems = items.filter((item) => {
                    return query.every((token) => {
                        return item.tokens.includes(token);
                    })
                });
            }
            newItems.sort((a, b) => {
                let ret = (a.open === b.open)
                if (ret) return 0;
                return a.open ? -1 : 1;
            })
            return newItems;
        },
        groupByStatus(item) {
            return item.status;
        },
    },
    async mounted() {
        if (this.showWhenLoaded) {
            this.$refs.crud.fetch(this.showWhenLoaded)
        }
    }
}
</script>
